import script from "./IfcWorkbench.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcWorkbench.vue?vue&type=script&setup=true&lang=ts"

import "./IfcWorkbench.vue?vue&type=style&index=0&id=50e0a7be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e0a7be"]])

export default __exports__